import { Stack } from "@mui/material";
import { Paragraph } from "components/Typography";
import i18next from "i18n";

const ColumnShape = [
  {
    Header: i18next.t("EmployeeDirectory.list.columns.name"),
    accessor: "name",
    Cell: ({ row }) => {
      const { name } = row.original;
      return (
        <Stack direction="row" spacing={1} alignItems="center">
          <Paragraph fontSize={13} color="text.secondary">
            {name}
          </Paragraph>
        </Stack>
      );
    },
  },
  {
    Header: i18next.t("EmployeeDirectory.list.columns.employeeId"),
    accessor: "employee_id",
    Cell: ({ row }) => {
      const { employee_id } = row.original;
      return (
        <Stack direction="row" spacing={1} alignItems="center">
          <Paragraph fontSize={13} color="text.secondary">
            {employee_id}
          </Paragraph>
        </Stack>
      );
    },
  },
  {
    Header: i18next.t("EmployeeDirectory.list.columns.job"),
    accessor: "job",
    Cell: ({ row }) => {
      const { job } = row.original;
      return (
        <Stack direction="row" spacing={1} alignItems="center">
          <Paragraph fontSize={13} color="text.secondary">
            {job}
          </Paragraph>
        </Stack>
      );
    },
  },
  /*{
    Header: i18next.t("EmployeeDirectory.list.columns.role"),
    accessor: "role",
    Cell: ({ row }) => {
      const { role } = row.original;
      return (
        <Stack direction="row" spacing={1} alignItems="center">
          <Paragraph fontSize={13} color="text.secondary">
            {role}
          </Paragraph>
        </Stack>
      );
    },
  },*/
  {
    Header: i18next.t("EmployeeDirectory.list.columns.entity"),
    accessor: "entity",
    Cell: ({ row }) => {
      const { entity } = row.original;
      return (
        <Paragraph fontSize={13} color="text.secondary">
          {entity}
        </Paragraph>
      );
    },
  },
];
export default ColumnShape;
